import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var quizResultRes;
export const quizResultTodo = createAsyncThunk('quizResult', async (id) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/view_quiz_result',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "learning_quiz_id": id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return quizResultRes = res.data
    } catch (error) {
        return quizResultRes = error.response.data
    }
})


const quizResultSlice = createSlice({
    name: 'quizResult',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(quizResultTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('quizResult', state.data)
            }
        });
        builder.addCase(quizResultTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default quizResultSlice.reducer; 